import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import ServiceTicket from "./panles/ServiceTicket";
import AppService from "../../../../Configurations/Appservice";
import {
  dismissLoader,
  showLoader,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { CustomerDashStyle } from "./Style";
import uuid from "react-uuid";
import { APP_CONSTANTS } from "../../../../Configurations/AppConstants";

const CustomerDashboard = () => {
  const [pendingTickets, setPendingTickets] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [organisation, setOrganisation] = useState("*");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Customer Dashboard"));
    return () => dispatch(updateScreenTitle(""));
  });

  useEffect(() => {
    dispatch(showLoader());
    const params = { orgId: organisation === "*" ? null : organisation };
    
    // Log the auth info for debugging
    const authInfo = localStorage.getItem("authInfo");
    console.log("Auth info in dashboard:", authInfo);
    
    // Use the dashboard endpoint
    AppService.get("v1/dashboard/admin/customerDash", { params })
      .then((response) => {
        console.log("Dashboard response:", response);
        setPendingTickets(response.pendingCustomerTickets || []);
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      })
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, [organisation]);

  useEffect(() => {
    const params = { type: "CUSTOMER" };
    
    // Log the request for debugging
    console.log("Fetching organizations with params:", params);
    
    AppService.get("v1/organisation/keyValues", { params })
      .then((response) => {
        console.log("Organizations response:", response);
        setOrganisations(response);
      })
      .catch((error) => {
        console.error("Error fetching organizations:", error);
      })
      .finally(() => {});
  }, []);

  const _navigateToPendingTickets = (ticket) => {
    // if()
    // navigate("/ADM-Customer/pending-customer-tickets", {
    //   state: {
    //     ticket,
    //   },
    // });

    navigate("/ADM-Ticket/pending-tickets", {
      state: {
        customerOrganisation: organisation === "*" ? null : organisation,
        screenType: APP_CONSTANTS.ADMIN_DASH,
        status: "OPEN",
        serviceId: ticket.serviceId,
      },
    });
  };

  const _renderPendingTickets = (ticket) => {
    return (
      <Grid item xs={12} sm={3} key={uuid()}>
        <ServiceTicket ticket={ticket} onClick={() => _navigateToPendingTickets(ticket)} />
      </Grid>
    );
  };

  const EmptyTicketInfo = () => {
    return (
      <Box m={2}>
        <Card sx={{ p: 2 }}>
          <Typography fontSize={14}>No Tickets Pending</Typography>
        </Card>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Grid container>
        <Grid item xs={6}>
          <Card>
            <Box p={2}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">Customer Organisation</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={organisation}
                  label="Customer Organisation"
                  onChange={(event) => setOrganisation(event.target.value)}
                >
                  <MenuItem value="*">All</MenuItem>
                  {organisations &&
                    organisations.map(({ id, name }) => <MenuItem value={id}>{name}</MenuItem>)}
                </Select>
              </FormControl>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Box my={3}>
        <Grid container spacing={1.5}>
          {pendingTickets && pendingTickets.map(_renderPendingTickets)}
          {!pendingTickets.length && <EmptyTicketInfo />}
        </Grid>
      </Box>
    </Box>
  );
};

export default CustomerDashboard;
